export enum CenterTrainingTypeEnum {
    ClassroomTraining = 0,
    DrivingTraining = 2
}
